/*
 * Wishlist ERMOS — salva pecas no navegador do cliente (localStorage), reflete o
 * estado nos coracoes e abre o drawer (mesmo design do cart drawer).
 * Feedback visual ao favoritar: pop no coracao do card + coracao "voando" ate o
 * header + pulse no icone do header (ver playFeedback/flyHeart). O CSS das
 * animacoes fica em sections/header.liquid ({% stylesheet %} e global no tema).
 * - Coracao nos cards: [data-wishlist-toggle][data-wishlist-handle] (snippets/product-card.liquid)
 * - Coracao do header: [data-wishlist-trigger]; o <sup data-wishlist-count> existe
 *   no DOM (integracoes) mas NUNCA e exibido — a wishlist nao tem contador visual.
 * - Drawer: #ErmosWishlistDrawer em layout/theme.liquid; itens renderizados a partir de
 *   /products/{handle}.js (AJAX API nativa do Shopify).
 * Delegacao em document: funciona em qualquer card, inclusive injetado via AJAX.
 */
(function () {
  if (window.__ermosWishlistInit) return;
  window.__ermosWishlistInit = true;

  var KEY = 'ermos:wishlist';
  var moneyFormat = (window.ermosMoneyFormat || 'R$ {{amount_with_comma_separator}}');

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    syncUI(list);
  }
  function has(list, handle) { return list.indexOf(handle) !== -1; }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var br = moneyFormat.indexOf('comma_separator') !== -1;
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, br ? '.' : ',');
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, intPart + (br ? ',' : '.') + parts[1]);
  }

  /* ---------- Sync de todos os coracoes + contador do header ---------- */
  function syncUI(list) {
    list = list || read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = has(list, btn.getAttribute('data-wishlist-handle'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var trigger = document.querySelector('[data-wishlist-trigger]');
    var count = document.querySelector('[data-wishlist-count]');
    if (trigger) trigger.classList.toggle('is-active', list.length > 0);
    if (count) {
      count.textContent = list.length;
      count.hidden = list.length === 0;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var list = read();
    /* Fonte de verdade unica: o estado e decidido e gravado aqui, uma so vez.
       playFeedback e APENAS representacao visual — nao mexe na lista. */
    var added = !has(list, handle);
    if (added) list.push(handle);
    else list = list.filter(function (h) { return h !== handle; });
    write(list);
    playFeedback(btn, added);
    if (drawer && !drawer.hidden) renderDrawer();
  }, true);

  /* ---------- Feedback visual (microinteracao) ---------- */
  var reduceMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function prefersReducedMotion() { return !!(reduceMotionQuery && reduceMotionQuery.matches); }

  /* Reinicia a animacao mesmo em cliques rapidos consecutivos (forca reflow). */
  function restartAnim(el, cls) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    var done = function () {
      el.classList.remove(cls);
      el.removeEventListener('animationend', done);
      el.removeEventListener('animationcancel', done);
    };
    el.addEventListener('animationend', done);
    el.addEventListener('animationcancel', done);
  }

  function pulseHeaderHeart() {
    var t = document.querySelector('[data-wishlist-trigger]');
    if (!t) return;
    restartAnim(t, prefersReducedMotion() ? 'wl-fade' : 'wl-pulse');
  }

  var FLY_MS = 640;

  /* Clona o proprio SVG do coracao do card e o anima ate o coracao do header.
     Posicoes sempre calculadas na hora via getBoundingClientRect (nunca fixas),
     entao funciona em qualquer viewport, scroll ou posicao do carrossel.
     O botao original NAO se move: o elemento animado e um clone descartavel. */
  function flyHeart(btn, onArrive) {
    var target = document.querySelector('[data-wishlist-trigger]');
    var srcIcon = btn.querySelector('svg');
    if (!target || !srcIcon || typeof srcIcon.animate !== 'function' || document.hidden) {
      onArrive();
      return;
    }
    var from = srcIcon.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) { onArrive(); return; }

    var size = Math.max(16, Math.round(from.width));
    var clone = document.createElement('span');
    clone.className = 'wl-fly';
    clone.setAttribute('aria-hidden', 'true');
    clone.style.width = size + 'px';
    clone.style.height = size + 'px';
    clone.style.left = Math.round(from.left + from.width / 2 - size / 2) + 'px';
    clone.style.top = Math.round(from.top + from.height / 2 - size / 2) + 'px';
    clone.appendChild(srcIcon.cloneNode(true));
    document.body.appendChild(clone);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    /* Ponto de controle deslocado para cima: a trajetoria vira um arco, nao uma reta. */
    var lift = Math.max(40, Math.min(160, Math.abs(dx) * 0.3 + Math.abs(dy) * 0.12));

    var finished = false;
    var cleanup = function () {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
    };
    var finish = function () {
      if (finished) return;
      finished = true;
      cleanup();
      onArrive();
    };

    var anim = clone.animate(
      [
        { transform: 'translate3d(0,0,0) scale(1)', opacity: 1, offset: 0, easing: 'cubic-bezier(.22,.61,.36,1)' },
        { transform: 'translate3d(' + (dx * 0.5) + 'px,' + (dy * 0.5 - lift) + 'px,0) scale(0.82)', opacity: 0.95, offset: 0.55, easing: 'cubic-bezier(.55,.06,.68,.19)' },
        { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(0.35)', opacity: 0, offset: 1 }
      ],
      { duration: FLY_MS, fill: 'forwards' }
    );

    anim.addEventListener('finish', finish);
    anim.addEventListener('cancel', function () { if (!finished) { finished = true; cleanup(); } });
    /* Rede de seguranca: se 'finish' nao disparar (aba em background, por ex.),
       o clone ainda assim sai do DOM — nada de elemento fantasma. */
    setTimeout(finish, FLY_MS + 400);
  }

  function playFeedback(btn, added) {
    var reduced = prefersReducedMotion();
    if (!added) {
      /* Remover: so feedback local discreto, sem voo ate o header. */
      if (!reduced) restartAnim(btn, 'wl-dip');
      return;
    }
    if (reduced) { pulseHeaderHeart(); return; }
    restartAnim(btn, 'wl-pop');
    flyHeart(btn, pulseHeaderHeart);
  }

  /* ---------- Drawer (mesmo padrao do cart-drawer.js) ---------- */
  var drawer = document.querySelector('[data-wishlist-drawer]');
  var scrim = document.querySelector('[data-wishlist-drawer-scrim]');
  /* O botão do header é buscado na hora (a section do header pode ser recriada pelo
     Theme Editor); o clique é delegado em document. */
  function getTrigger() { return document.querySelector('[data-wishlist-trigger]'); }
  var itemsEl = drawer && drawer.querySelector('[data-wishlist-items]');
  var emptyTpl = drawer && drawer.querySelector('[data-wishlist-empty]');
  var cache = {};

  function onKeydown(e) { if (e.key === 'Escape' || e.key === 'Esc') closeDrawer(); }

  /* Mesmo scroll-lock dos demais painéis (menu, busca, carrinho): a página de trás não
     rola enquanto a wishlist está aberta, e volta exatamente à mesma posição ao fechar. */
  var lockedY = null, lastFocused = null, wlOpen = false;
  function lockScroll() {
    if (lockedY !== null || document.body.style.position === 'fixed') return;
    lockedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = -lockedY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlockScroll() {
    if (lockedY === null) return;
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, lockedY);
    lockedY = null;
  }

  function openDrawer() {
    if (!drawer) return;
    if (wlOpen) return;
    wlOpen = true;
    renderDrawer();
    lockScroll();
    lastFocused = document.activeElement;
    drawer.hidden = false;
    if (scrim) scrim.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (scrim) { scrim.classList.add('is-open'); scrim.setAttribute('aria-hidden', 'false'); }
    });
    var trigger = getTrigger();
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKeydown);
    var closeBtn = drawer.querySelector('[data-wishlist-drawer-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer || !wlOpen) return;
    wlOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) { scrim.classList.remove('is-open'); scrim.setAttribute('aria-hidden', 'true'); }
    var trigger = getTrigger();
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
    unlockScroll();
    if (lastFocused && lastFocused !== document.body && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
    setTimeout(function () {
      if (wlOpen) return;
      drawer.hidden = true;
      if (scrim) scrim.hidden = true;
    }, 280);
  }
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-trigger]')) { openDrawer(); return; }
    if (e.target.closest('[data-wishlist-drawer-close]')) closeDrawer();
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) {
      var h = rm.getAttribute('data-wishlist-remove');
      write(read().filter(function (x) { return x !== h; }));
      renderDrawer();
    }
  });

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderDrawer() {
    if (!itemsEl) return;
    var list = read();
    var title = drawer.querySelector('[data-wishlist-title]');
    if (title) title.textContent = list.length === 0 ? 'Wishlist' : (list.length === 1 ? '1 peça salva' : list.length + ' peças salvas');
    if (list.length === 0) {
      itemsEl.innerHTML = emptyTpl ? emptyTpl.innerHTML : '';
      return;
    }
    Promise.all(list.map(fetchProduct)).then(function (products) {
      var html = '';
      products.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
        var soldOut = !p.available;
        html += '<div class="cart-drawer__block cart-drawer__item">' +
          '<a href="' + escapeHtml(p.url) + '" class="cart-drawer__item-image" data-wishlist-drawer-close>' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" decoding="async" fetchpriority="high">' : '') +
          '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<a href="' + escapeHtml(p.url) + '" class="cart-drawer__item-title" data-wishlist-drawer-close>' + escapeHtml(p.title) + '</a>' +
            '<span class="cart-drawer__item-price">' + (soldOut ? 'Esgotado' : formatMoney(p.price)) + '</span>' +
            '<div class="cart-drawer__item-controls">' +
              '<a href="' + escapeHtml(p.url) + '" class="wishlist-drawer__cta" data-wishlist-drawer-close>Ver peça</a>' +
              '<button type="button" class="cart-drawer__remove" data-wishlist-remove="' + escapeHtml(list[i]) + '" aria-label="Remover ' + escapeHtml(p.title) + ' da wishlist">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="16" height="16"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      });
      itemsEl.innerHTML = html;
    });
  }

  /* Pré-aquece o cache da wishlist quando o navegador estiver ocioso: ao abrir a gaveta,
     fetchProduct devolve do cache e a lista aparece de imediato. */
  function warmCache() { read().forEach(fetchProduct); }
  if (window.requestIdleCallback) requestIdleCallback(warmCache, { timeout: 4000 });
  else setTimeout(warmCache, 1500);

  /* Cards injetados via AJAX (grid da collection) */
  document.addEventListener('ermos:cards:refresh', function () { syncUI(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncUI(); });
  else syncUI();
})();
